module.exports = __webpack_public_path__ + "assets/img/worldviewImgActive-add66762.png";